var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InformationItem',_vm._b({attrs:{"items":_vm.items,"compact":"true"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Address ")]},proxy:true},{key:"item",fn:function({item}){return [(item.value)?_c('span',[_vm._v(" "+_vm._s(item.value)+" ")]):_vm._e()]}}])},'InformationItem',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }